var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3327 10.0837V10.917C18.3327 11.1471 18.1461 11.3337 17.916 11.3337H2.08268C1.85256 11.3337 1.66602 11.1471 1.66602 10.917V10.0837C1.66602 9.85354 1.85256 9.66699 2.08268 9.66699H17.916C18.1461 9.66699 18.3327 9.85354 18.3327 10.0837ZM2.08268 14.667H17.8989C18.129 14.667 18.3156 14.8535 18.3156 15.0837V15.917C18.3156 16.1471 18.129 16.3337 17.8989 16.3337H2.08268C1.85256 16.3337 1.66602 16.1471 1.66602 15.917V15.0837C1.66602 14.8535 1.85256 14.667 2.08268 14.667ZM2.08268 4.66699H17.8971C18.1272 4.66699 18.3138 4.85354 18.3138 5.08366V5.91699C18.3138 6.14711 18.1272 6.33366 17.8971 6.33366H2.08268C1.85256 6.33366 1.66602 6.14711 1.66602 5.91699V5.08366C1.66602 4.85354 1.85256 4.66699 2.08268 4.66699Z",
    fill: "#21272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger_menu.bf3bd98a.svg";
export { ForwardRef as ReactComponent };